/* eslint-disable no-undef */
// @ts-nocheck

import { getWigzoDataBody } from '../services/Helper.service';

export const callWigzo = (eventName, data) => {
  if (eventName == 'userAddress') {
    identifyCall(
      data.userAddress?.email,
      `+91${data.phoneNumber}`,
      data.evt.userAddress?.firstname + ' ' + data.evt.userAddress?.lastname
    );
    // added timeout to wait for identify call to resolve
    setTimeout(() => {
      wigzoUserAddressInfo(data);
    }, 1500);
  }
};

const identifyCall = (email, phone, fullName) => {
  wigzo('identify', {
    email: email,
    phone: phone,
    fullName: fullName,
  });
};

const wigzoUserAddressInfo = (data) => {
  let credentials = getWigzoDataBody(data);
  wigzo(credentials.eventType, credentials.eventName, credentials.data);
};
